import merge from "lodash/merge";
import { getReservationsByTask, checkWorker, checkReservationExists } from "../../ActionUtils";
import { Task } from "~/packages/taskrouter";
import { ErrorCode, ErrorSeverity } from "~/modules/error";
import { getLogger, LoggerName } from "~/modules/logger";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { sendWorkerTrackingEvent, toCauseMessage } from "~/modules/telemetry/utils";
import { EVENTS } from "~/modules/telemetry/Analytics";
import { AnalyticsImpl } from "~/modules/telemetry/AnalyticsImpl";
import { Action } from "~/modules/actions/Action";
import { createFlexSdkError } from "~/modules/error/ThrowError/ErrorHelper";



export interface SetTaskAttributesOptions {
    mergeExisting?: boolean;
}


































export class SetTaskAttributes implements Action<Promise<Task>> {
    


    readonly #taskSid: string;

    


    readonly #attributes: Record<any, any>;

    


    readonly #options?: SetTaskAttributesOptions;

    constructor(taskSid: string, attributes: Record<any, any>, options?: SetTaskAttributesOptions) {
        this.#taskSid = taskSid;
        this.#attributes = attributes;
        this.#options = options;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const mergeExisting = this.#options?.mergeExisting ?? false;
        const taskRouter = context.retrieveInstanceOf(ContextInstance.TaskRouter, TaskRouterImpl);
        await taskRouter.init();
        const logger = getLogger(context)(LoggerName.Actions);
        const worker = taskRouter.worker;
        const analytics = context.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);

        logger.debug(`setTaskAttributes invoked with taskSid: ${this.#taskSid}`);

        const commons = {
            actionName: "SetTaskAttributes",
            moduleName: "actions/Task",
            logger,
            analytics,
            context,
            worker
        };
        checkWorker(worker, {
            ...commons,
            event: EVENTS.SetTaskAttributesCompleted,
            extra: {
                mergeExisting
            }
        });

        const reservation = getReservationsByTask(worker, this.#taskSid)[0];
        checkReservationExists(reservation, this.#taskSid, {
            ...commons,
            event: EVENTS.SetTaskAttributesCompleted,
            extra: {
                taskSid: this.#taskSid,
                mergeExisting
            }
        });

        const task = reservation.task;

        try {
            const newAttributes = mergeExisting ? merge(task?.attributes, this.#attributes) : this.#attributes;
            await task.setAttributes(newAttributes);

            sendWorkerTrackingEvent(EVENTS.SetTaskAttributesCompleted, analytics, worker, {
                taskSid: this.#taskSid,
                mergeExisting
            });

            return task;
        } catch (error) {
            const errorMsg = `SetTaskAttributes: Failed to set attributes for task ${this.#taskSid}`;
            const errorMessage = toCauseMessage(error);
            sendWorkerTrackingEvent(EVENTS.SetTaskAttributesCompleted, analytics, worker, {
                error: `${errorMsg} (${errorMessage})`,
                taskSid: this.#taskSid,
                mergeExisting
            });
            return Promise.reject(
                createFlexSdkError(context)(
                    ErrorCode.FailedToSetTaskAttributes,
                    { severity: ErrorSeverity.Error },
                    errorMsg,
                    error
                )
            );
        }
    }
}
